<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as TASK_CATEGORY_TYPE_TYPES } from '../../task-category-type/store'

export default {
  name: 'MacroTypeMixin',
  created () {
    if (!this.taskCategoryTypeList || !this.taskCategoryTypeList.results ||
        this.taskCategoryTypeList.results.length === 0) {
      this.getTaskCategoryTypeList({ filter__status: 1 })
    }
  },
  computed: {
    ...mapGetters({
      taskCategoryTypeList:
        TASK_CATEGORY_TYPE_TYPES.GENERIC.task['task-category-type'].LIST.GETTERS.list
    }),
    macroTypeListOptions () {
      if (!this.taskCategoryTypeList || !this.taskCategoryTypeList.results) return []
      return this.taskCategoryTypeList.results
        .filter((item) => item.status !== 0)
        .map((item) => ({ value: item.id, text: item.name }))
    }
  },
  methods: {
    ...mapActions({
      getTaskCategoryTypeList:
        TASK_CATEGORY_TYPE_TYPES.GENERIC.task['task-category-type'].LIST.ACTIONS.setFilters
    }),
    selectMacroType (item) {
      this.$set(this.form, 'type', item.value)
      this.$set(this.form, 'type_name', item.text)
    },
    clearMacroType () {
      this.$set(this.form, 'type', null)
      this.$set(this.form, 'type_name', null)
    }
  }
}
</script>
